import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="relative z-10 py-20 px-4 bg-[#0d1333]/50 border-y border-white/5" data-id="element-126">
      <div className="max-w-3xl mx-auto" data-id="element-127">
        <FadeIn data-id="element-128">
          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-129">
            <AlertTriangleIcon className="w-8 h-8 text-amber-500" data-id="element-130" />
            <h2 className="text-3xl md:text-4xl font-bold text-white text-center" data-id="element-131">
              El Verdadero Problema
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-132">
          <FadeIn delay={0.1} data-id="element-133">
            <p data-id="element-134">
              El insomnio por ansiedad no es una falta de sueño;{' '}
              <strong className="text-white font-semibold" data-id="element-135">
                es un exceso de alerta
              </strong>
              . Tu cuerpo está en modo "supervivencia" porque tu cerebro cree
              que hay amenazas pendientes por resolver.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-136">
            <p data-id="element-137">
              Mientras el cortisol (la hormona del estrés) inunde tu sangre,
              ninguna cantidad de té de manzanilla o música de lluvia te hará
              dormir. Estás intentando apagar un incendio forestal con un vaso
              de agua.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="p-6 bg-red-900/10 border border-red-500/20 rounded-xl mt-8" data-id="element-138">
            <p className="text-red-200 italic text-center" data-id="element-139">
              "Mañana te espera el mismo cansancio nublado, la falta de enfoque
              y la irritabilidad de siempre."
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}